import Model, { hasMany } from '@warp-drive/legacy/model';
import type ScheduleModel from './schedule.ts';
import { Type } from '@warp-drive/core-types/symbols';

export default class OwnerModel extends Model {
  /*************************
   **  Relationships      **
   *************************/
  @hasMany('schedule', {
    async: false,
    inverse: 'owner',
    as: 'owner',
  })
  declare schedules: ScheduleModel[];

  [Type] = 'owner' as const;
}
